/** A saved turn trace (turn_trace.TurnTraceWriter.render) as the steps the live
 * feed shows: each with the agent that took it. A delegation's steps follow a
 * "[delegation] <label>" line, indented four spaces; unindented steps are the
 * turn's own agent's. */
import { agentDisplayLabel } from "./runParticipants";

export interface TraceStep {
  who: string;
  text: string;
  thinking: boolean;
}

const DELEGATION = /^\[delegation\] (.+)$/;
const KIND = /^\[([a-z_]+)\] /;

export const turnTraceSteps = (trace: string, ownAgent: string): TraceStep[] => {
  let group = "";
  const steps: TraceStep[] = [];
  for (const raw of trace.split("\n")) {
    if (!raw.trim()) continue;
    const line = raw.trim();
    const header = DELEGATION.exec(line);
    if (header) {
      group = agentDisplayLabel(header[1]);
      continue;
    }
    const kind = KIND.exec(line)?.[1];
    // The writer indents only a step's first line, so a line with no [kind] is the
    // rest of the step above it.
    const previous = steps[steps.length - 1];
    if (!kind && previous) {
      previous.text = `${previous.text} ${line}`;
      continue;
    }
    const nested = raw.startsWith("    ");
    steps.push({
      who: nested && group ? group : ownAgent,
      text: kind ? line.slice(kind.length + 3) : line,
      thinking: kind === "thinking",
    });
  }
  return steps;
};
